var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIconBatchProcessing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "batch",
    width: 28.3,
    height: 33.8,
    viewBox: "0 0 28.3 33.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1,
    height: 5.5,
    transform: "translate(0.9 27.4)",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,.9H0A.9.9,0,0,1-.9,0,.9.9,0,0,1,0-.9H15a.9.9,0,0,1,.9.9A.9.9,0,0,1,15,.9Z",
    transform: "translate(1 32.9)",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.9,33.8a.9.9,0,0,1-.9-.9V6.8a.9.9,0,0,1,.9-.9H21.5a.9.9,0,0,1,.9.9V27.4a.9.9,0,1,1-1.8,0V7.7H1.8V32.9A.9.9,0,0,1,.9,33.8Z",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.6,
    height: 20.6,
    transform: "translate(0.9 6.8)",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,26.5h5.5a.9.9,0,0,1,.636,1.536l-5.5,5.5A.9.9,0,0,1,15.1,32.9V27.4A.9.9,0,0,1,16,26.5Zm3.327,1.8H16.9v2.427Z",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H6.9a.4.4,0,0,1,.4.4A.4.4,0,0,1,6.9.4Z",
    transform: "translate(7.8 9.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H15.2a.4.4,0,0,1,.4.4A.4.4,0,0,1,15.2.4Z",
    transform: "translate(3.6 11.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H15.2a.4.4,0,0,1,.4.4A.4.4,0,0,1,15.2.4Z",
    transform: "translate(3.6 13.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H15.2a.4.4,0,0,1,.4.4A.4.4,0,0,1,15.2.4Z",
    transform: "translate(3.6 15.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H15.2a.4.4,0,0,1,.4.4A.4.4,0,0,1,15.2.4Z",
    transform: "translate(3.6 17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H15.2a.4.4,0,0,1,.4.4A.4.4,0,0,1,15.2.4Z",
    transform: "translate(3.6 18.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H15.2a.4.4,0,0,1,.4.4A.4.4,0,0,1,15.2.4Z",
    transform: "translate(3.6 20.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H15.2a.4.4,0,0,1,.4.4A.4.4,0,0,1,15.2.4Z",
    transform: "translate(3.6 22.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H15.2a.4.4,0,0,1,.4.4A.4.4,0,0,1,15.2.4Z",
    transform: "translate(3.6 24.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H10a.4.4,0,0,1,.4.4A.4.4,0,0,1,10,.4Z",
    transform: "translate(3.6 27.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H7.4a.4.4,0,0,1,.4.4A.4.4,0,0,1,7.4.4Z",
    transform: "translate(6.2 29.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,.4H0A.4.4,0,0,1-.4,0,.4.4,0,0,1,0-.4H10a.4.4,0,0,1,.4.4A.4.4,0,0,1,10,.4Z",
    transform: "translate(3.6 26.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5.9H0A.9.9,0,0,1-.9,0,.9.9,0,0,1,0-.9H23.5a.9.9,0,0,1,.9.9A.9.9,0,0,1,23.5.9Z",
    transform: "translate(1 3.8)",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,24.4a.9.9,0,0,1-.9-.9V0A.9.9,0,0,1,0-.9.9.9,0,0,1,.9,0V23.5A.9.9,0,0,1,0,24.4Z",
    transform: "translate(24.5 3.8)",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,.9H0A.9.9,0,0,1-.9,0,.9.9,0,0,1,0-.9H25a.9.9,0,0,1,.9.9A.9.9,0,0,1,25,.9Z",
    transform: "translate(2.4 0.9)",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,25.8a.9.9,0,0,1-.9-.9V0A.9.9,0,0,1,0-.9.9.9,0,0,1,.9,0V24.9A.9.9,0,0,1,0,25.8Z",
    transform: "translate(27.4 0.9)",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 2.4,
    transform: "translate(16 27.4)",
    fill: "#3a3630",
    className: "color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.9H2.4a.9.9,0,0,1,.9.9V2.4a.9.9,0,0,1-.9.9H0a.9.9,0,0,1-.9-.9V0A.9.9,0,0,1,0-.9ZM1.5.9H.9v.6h.6Z",
    transform: "translate(16 27.4)",
    fill: "#3a3630",
    className: "color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconBatchProcessing);
export default __webpack_public_path__ + "static/media/settingsIcon_BatchProcessing.70657c72916d5716cf299c4961546c1f.svg";
export { ForwardRef as ReactComponent };